import { CurrentUser } from "#root/queries/users";
import { RootState } from "#store/store";

export const getIsAuthenticated = (state: RootState): boolean => 
  state.auth.isAuthenticated;

export const getIsCurrentUserLoading = (state: RootState): boolean => 
  state.auth.currentUserLoading;

export const getIsTokensLoading = (state: RootState): boolean => 
  state.auth.tokensLoading;

export const getError = (state: RootState): string | null => 
  state.auth.error;

export const getCurrentUser = (state: RootState): CurrentUser | null => 
  state.auth.currentUser;
